<script setup lang="ts">
import type { SiteSettingContentQuickLinkContent } from '~/types';

defineProps<{
  quickLinkContent: SiteSettingContentQuickLinkContent;
}>();
</script>

<template>
  <nav>
    <ul
      :aria-label="$t('Aria.Global.Footer.QuickLinkList', { headline: quickLinkContent.headline })"
      class="grid gap-2"
    >
      <li
        v-for="quickLink in quickLinkContent.links"
        :key="quickLink.name"
        class="hyphens-auto text-white"
      >
        <UmbracoLink
          :link="quickLink"
          :has-underline="true"
          class="text-base"
        />
      </li>
    </ul>
  </nav>
</template>
